import type {
  DocumentViewerState,
  NormalizedEntityForStore,
  NormalizedSummaryForStore,
} from '@/common/document-viewer/types'

import { DocumentViewerMutationTypes } from './mutation_types'

export const mutations: StoreMutations<DocumentViewerMutationTypes, DocumentViewerState> = {
  [DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_DIALOG] (state, value) {
    state.redactDocumentDialogIsOpen = value
  },
  [DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_ERROR] (state, value) {
    state.redactDocumentError = value
  },
  [DocumentViewerMutationTypes.SEARCH_BY_AI_PENDING](state, value) {
    state.searchByAIPending = value
  },
  [DocumentViewerMutationTypes.SET_SEARCH_BY_AI_RESULTS](state, value) {
    state.searchByAIResults = value
  },
  [DocumentViewerMutationTypes.SEARCH_BY_AI_PUSH_ENTITY](
    state,
    entity: NormalizedEntityForStore,
  ) {
    if (!entity || !entity.type) return
    const entityType = entity.type
    if (!state.searchByAIResults.results[entityType]) {
      state.searchByAIResults.results[entityType] = []
    }
    state.searchByAIResults.results[entityType].push({
      text: entity.text,
      id: entity.id,
      type: entity.type,
    })
  },
  [DocumentViewerMutationTypes.SEARCH_BY_AI_SET_SUMMARY](
    state,
    summary: NormalizedSummaryForStore,
  ) {
    state.searchByAIResults.summary = summary
  },
  [DocumentViewerMutationTypes.SEARCH_BY_AI_ERROR](state, value) {
    state.searchByAIError = value
  },
}
